__turbopack_context__.v({
  "icon": "OY3Y5W_icon",
  "inner": "OY3Y5W_inner",
  "maximize": "OY3Y5W_maximize",
});
